import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import type { LockerStatus } from '../lockers/common';
import { STATUS_COLOR } from '../lockers/common';

export const OSM_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

/** Pin colorat după stare, fără imagini (Leaflet-ul implicit cere PNG-uri). */
export function pinIcon(status: LockerStatus, selected = false): L.DivIcon {
  const color = STATUS_COLOR[status];
  const size = selected ? 22 : 16;
  return L.divIcon({
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    html: `<span style="display:block;width:${size}px;height:${size}px;border-radius:50%;background:${color};border:3px solid #fff;box-shadow:0 0 0 2px ${color}55, 0 4px 10px #18273c33"></span>`,
  });
}

function Recenter({ lat, lng }: { lat: number; lng: number }) {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], map.getZoom(), { animate: false });
  }, [lat, lng, map]);
  return null;
}

function ClickPick({ onPick }: { onPick?: (lat: number, lng: number) => void }) {
  useMapEvents({
    click: (e) => onPick?.(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6))),
  });
  return null;
}

/** Harta mică din tab-ul Locație: un singur locker; click pe hartă alege coordonatele (când e permis). */
export function MiniMap({
  lat,
  lng,
  status,
  label,
  onPick,
}: {
  lat: number;
  lng: number;
  status: LockerStatus;
  label: string;
  onPick?: (lat: number, lng: number) => void;
}) {
  return (
    <MapContainer
      center={[lat, lng]}
      zoom={14}
      style={{ height: 360, width: '100%', borderRadius: 'var(--r)' }}
      scrollWheelZoom={false}
      attributionControl
    >
      <TileLayer url={OSM_URL} attribution={OSM_ATTRIBUTION} />
      <Marker position={[lat, lng]} icon={pinIcon(status, true)} title={label} />
      <Recenter lat={lat} lng={lng} />
      <ClickPick onPick={onPick} />
    </MapContainer>
  );
}
